export const INSURANCE_CARD_PREVIEW_SX = {
  display: 'block',
  height: 160,
  maxWidth: '100%',
  width: 228,
} as const;

export const INSURANCE_CARD_PREVIEW_INTERACTIVE_SX = {
  cursor: 'pointer',
  '&:focus-visible': {
    outline: `2px solid`,
    outlineOffset: 2,
  },
} as const;
